/* Naht & Leinen – Beaubag-/Minibag-Seiten (Team B2): Video, Designkarten ↔ Craft-Variantenauswahl, Duo-Warenkorb,
   Set-Links, Karussell-Punkte, Versandbalken. Ergänzt nl.js und die Craft-Skripte (pubsub, product-info). */
(function () {
  'use strict';
  if (window.nlBeauAktiv) return;
  window.nlBeauAktiv = true;

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* PUB_SUB_EVENTS ist in constants.js als const deklariert (kein window-Attribut) */
  function ereignisse() { try { return PUB_SUB_EVENTS; } catch (e) { return null; } }
  var hatPubSub = function () { return typeof window.subscribe === 'function' && typeof window.publish === 'function' && !!ereignisse(); };

  /* ---------- Craft-Variantenauswahl lesen und setzen ---------- */
  function sichtbareAuswahl() {
    var alle = document.querySelectorAll('product-info variant-selects');
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].style.display !== 'none' && alle[i].offsetParent !== null) return alle[i];
    }
    return alle[0] || null;
  }

  function optionsName(el) { return (el.textContent || '').replace(/:[\s\S]*$/, '').trim(); }

  function aktuelleAuswahl() {
    var g = {};
    var vs = sichtbareAuswahl();
    if (!vs) return g;
    vs.querySelectorAll('fieldset, .product-form__input').forEach(function (feld) {
      var name = feld.querySelector('legend, label.form__label');
      var wert = feld.querySelector('input:checked') || feld.querySelector('select');
      if (name && wert) g[optionsName(name)] = (wert.value || '').trim();
    });
    return g;
  }

  function waehleOption(option, wert) {
    var vs = sichtbareAuswahl();
    if (!vs) return null;
    var radios = vs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (r.name.indexOf(option + '-') === 0 && r.value === wert) {
        if (!r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return r;
      }
    }
    var selects = vs.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      if (selects[j].name === 'options[' + option + ']') {
        selects[j].value = wert;
        selects[j].dispatchEvent(new Event('change', { bubbles: true }));
        return selects[j];
      }
    }
    return null;
  }

  /* Beste Variante eines Produkts zur aktuellen Auswahl (Set: Minibag-Design = Beaubag-Design, falls noch keins gewählt) */
  function besteVariante(daten, auswahl, setOption) {
    var g = Object.assign({}, auswahl);
    if (setOption && !g[setOption]) {
      var designName = Object.keys(g).filter(function (k) { return /design/i.test(k); })[0];
      if (designName) g[setOption] = g[designName];
    }
    var beste = null, punkte = -1;
    daten.varianten.forEach(function (v) {
      var p = 0;
      daten.optionen.forEach(function (o, i) { if (g[o] && g[o] === v.o[i]) p += 2; });
      if (v.a) p += 1;
      if (p > punkte) { punkte = p; beste = v; }
    });
    return beste;
  }

  function leseDaten(el) {
    try { return JSON.parse(el.getAttribute('data-varianten')); } catch (e) { return null; }
  }

  function zumKaufbereich(fokus) {
    var ziel = sichtbareAuswahl() || document.querySelector('product-info');
    if (!ziel) return;
    ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' });
    if (fokus && fokus.focus) setTimeout(function () { try { fokus.focus({ preventScroll: true }); } catch (e) { fokus.focus(); } }, ruhig ? 0 : 450);
  }

  /* ---------- Produkt-Umschalter (nl-geschwister): Minibag-Design wie Beaubag-Design vorschlagen ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-nl-ziel-varianten]');
    if (!a || a.getAttribute('aria-current') === 'page') return;
    try {
      var daten = JSON.parse(a.getAttribute('data-nl-ziel-varianten'));
      var g = aktuelleAuswahl();
      var setIdx = daten.optionen.indexOf('Minibag Design');
      if (setIdx < 0 || g['Minibag Design'] || !g['Beaubag Design']) return;
      var wunsch = g['Beaubag Design'];
      daten.varianten.sort(function (x, y) { return (y.o[setIdx] === wunsch) - (x.o[setIdx] === wunsch); });
      a.setAttribute('data-nl-ziel-varianten', JSON.stringify(daten));
    } catch (err) { /* Umschalter arbeitet wie gewohnt */ }
  }, true);

  /* ---------- Video: Klick zum Abspielen ---------- */
  function video(root) {
    var film = root.querySelector('video');
    var start = root.querySelector('[data-nl-beau-video-start]');
    if (!film || !start) return;
    film.removeAttribute('controls');
    start.hidden = false;
    start.addEventListener('click', function () {
      film.setAttribute('controls', '');
      root.classList.add('is-laeuft');
      start.hidden = true;
      var p = film.play();
      if (p && p.catch) p.catch(function () { /* Wiedergabe über die Steuerleiste */ });
      film.focus();
    });
    film.addEventListener('ended', function () { root.classList.remove('is-laeuft'); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (x) { if (!x.isIntersecting && !film.paused) film.pause(); });
      }, { threshold: 0.1 }).observe(root);
    }
  }

  /* ---------- Designkarten ---------- */
  /* Die App „Nestscale“ ersetzt die sichtbare Auswahl durch eine eigene Oberfläche; dann öffnen wir die Variante per Link,
     damit App-Anzeige, Bild und Preis sicher zusammenpassen. Ohne App wird direkt in der Craft-Auswahl gewählt. */
  function appAuswahlAktiv() {
    var ns = document.getElementById('nestscale-product-variant');
    return !!(ns && ns.children.length);
  }

  function designs(root) {
    var option = root.getAttribute('data-option');
    root.addEventListener('click', function (e) {
      var knopf = e.target.closest('[data-nl-beau-waehle]');
      if (!knopf) return;
      var opt = knopf.getAttribute('data-option') || option;
      var wert = knopf.getAttribute('data-wert');
      var daten = leseDaten(root);
      if (appAuswahlAktiv() || !sichtbareAuswahl()) {
        if (!daten) return; /* Link öffnet die serverseitig berechnete Variante */
        var g = aktuelleAuswahl();
        g[opt] = wert;
        var v = besteVariante(daten, g, null);
        if (!v) return;
        e.preventDefault();
        window.location.href = daten.url + '?variant=' + v.id;
        return;
      }
      var feld = waehleOption(opt, wert);
      if (!feld) return;
      e.preventDefault();
      markiereDesigns();
      zumKaufbereich(null);
    });
  }

  function markiereDesigns() {
    var g = aktuelleAuswahl();
    document.querySelectorAll('[data-nl-beau-designs]').forEach(function (root) {
      var wert = g[root.getAttribute('data-option')];
      if (!wert) return;
      root.querySelectorAll('[data-nl-beau-design-karte]').forEach(function (karte) {
        var aktiv = karte.getAttribute('data-wert') === wert;
        karte.classList.toggle('is-aktiv', aktiv);
        var k = karte.querySelector('[data-nl-beau-waehle]');
        if (k) { if (aktiv) k.setAttribute('aria-current', 'true'); else k.removeAttribute('aria-current'); }
      });
    });
  }

  /* ---------- Warenkorb (Craft-Schublade) ---------- */
  function inDenWarenkorb(variantId, ausloeser) {
    var schublade = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      fd.append('sections', schublade.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof schublade.setActiveElement === 'function') schublade.setActiveElement(ausloeser);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (antwort) {
        if (antwort.status) throw new Error(antwort.description || antwort.message || 'Fehler');
        if (hatPubSub()) window.publish(ereignisse().cartUpdate, { source: 'nl-beau', productVariantId: variantId, cartData: antwort });
        if (schublade && typeof schublade.renderContents === 'function') {
          schublade.classList.remove('is-empty');
          schublade.renderContents(antwort);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      });
  }

  /* ---------- Duo: vier Ausführungen ---------- */
  function duo(root) {
    var knopf = root.querySelector('[data-nl-beau-duo-knopf]');
    var text = knopf && knopf.querySelector('[data-nl-beau-knopftext]');
    var ausgabe = root.querySelector('[data-nl-beau-duo-auswahl]');
    var setOption = root.getAttribute('data-set-option') || 'Minibag Design';
    var eigen = root.getAttribute('data-produkt');
    if (!knopf) return;

    function gewaehlt() { return root.querySelector('input[type="radio"]:checked'); }

    function aktualisiere() {
      var r = gewaehlt();
      if (!r || !text) return;
      var istSet = r.getAttribute('data-ist-set') === 'true';
      text.textContent = istSet ? knopf.getAttribute('data-text-set') : knopf.getAttribute('data-text');
      var daten = leseDaten(r);
      var g = aktuelleAuswahl();
      if (!daten || !ausgabe) return;
      var v = besteVariante(daten, g, istSet ? setOption : null);
      if (!v) { ausgabe.textContent = ''; return; }
      var teile = v.o.slice();
      if (istSet && daten.optionen.indexOf(setOption) >= 0) {
        var i = daten.optionen.indexOf(setOption);
        teile[i] = 'Minibag ' + teile[i];
      }
      ausgabe.textContent = r.value === eigen ? '' : 'Mit deiner Auswahl: ' + teile.join(' · ');
    }

    root.addEventListener('change', function (e) { if (e.target.matches('input[type="radio"]')) aktualisiere(); });
    knopf.addEventListener('click', function () {
      var r = gewaehlt();
      if (!r) return;
      if (r.value === eigen) {
        var haupt = document.querySelector('product-info product-form button[type="submit"], product-info form[action*="/cart/add"] button[type="submit"]');
        if (haupt && !haupt.disabled) {
          haupt.click();
          return;
        }
      }
      var daten = leseDaten(r);
      if (!daten) return;
      var istSet = r.getAttribute('data-ist-set') === 'true';
      var v = besteVariante(daten, aktuelleAuswahl(), istSet ? setOption : null);
      if (!v) { window.location.href = daten.url; return; }
      knopf.setAttribute('aria-busy', 'true');
      knopf.disabled = true;
      inDenWarenkorb(v.id, knopf)
        .catch(function () { window.location.href = daten.url + '?variant=' + v.id; })
        .then(function () { knopf.removeAttribute('aria-busy'); knopf.disabled = false; });
    });
    aktualisiere();
    root.nlBeauAktualisiere = aktualisiere;
  }

  /* ---------- Minibag: Set-Links mit gewähltem Design ---------- */
  function setLinks() {
    var g = aktuelleAuswahl();
    document.querySelectorAll('[data-nl-beau-setlink]').forEach(function (a) {
      var daten = leseDaten(a);
      if (!daten) return;
      var v = besteVariante(daten, wunschFuerSet(g, a.getAttribute('data-option')), null);
      if (v) a.href = daten.url + '?variant=' + v.id;
    });
    document.querySelectorAll('[data-nl-beau-minisets]').forEach(function (root) {
      var r = root.querySelector('input[type="radio"]:checked');
      var knopf = root.querySelector('[data-nl-beau-miniset-knopf]');
      if (!r || !knopf) return;
      var daten = leseDaten(r);
      if (!daten) return;
      var v = besteVariante(daten, wunschFuerSet(g, root.getAttribute('data-option')), null);
      knopf.href = daten.url + (v ? '?variant=' + v.id : '');
    });
  }

  function wunschFuerSet(g, option) {
    var wert = g[option || 'Minibag Design'];
    var w = {};
    if (wert) { w['Minibag Design'] = wert; w['Beaubag Design'] = wert; }
    return w;
  }

  /* ---------- Karussell mit Punkten und Pfeilen ---------- */
  function karussell(root) {
    var spur = root.querySelector('[data-nl-beau-spur]');
    var punkte = root.querySelector('[data-nl-beau-punkte]');
    var zurueck = root.querySelector('[data-nl-beau-zurueck]');
    var weiter = root.querySelector('[data-nl-beau-weiter]');
    if (!spur) return;

    function karten() { return Array.prototype.filter.call(spur.children, function (k) { return k.offsetParent !== null; }); }
    function schritt() {
      var k = karten();
      if (k.length < 2) return spur.clientWidth;
      return k[1].getBoundingClientRect().left - k[0].getBoundingClientRect().left;
    }
    function scrollbar() { return spur.scrollWidth - spur.clientWidth > 4; }
    function stellen() {
      var s = schritt();
      if (!s) return 1;
      return Math.max(1, Math.round((spur.scrollWidth - spur.clientWidth) / s) + 1);
    }
    function index() { var s = schritt(); return s ? Math.round(spur.scrollLeft / s) : 0; }
    function gehe(i) { spur.scrollTo({ left: i * schritt(), behavior: ruhig ? 'auto' : 'smooth' }); }

    function baue() {
      if (!punkte) return;
      punkte.innerHTML = '';
      if (!scrollbar()) return;
      var n = stellen();
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Zu Position ' + (i + 1) + ' von ' + n);
        b.addEventListener('click', gehe.bind(null, i));
        punkte.appendChild(b);
      }
      zustand();
    }
    function zustand() {
      var i = index();
      if (punkte) Array.prototype.forEach.call(punkte.children, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (zurueck) zurueck.disabled = spur.scrollLeft <= 2;
      if (weiter) weiter.disabled = spur.scrollLeft + spur.clientWidth >= spur.scrollWidth - 2;
    }
    if (zurueck) zurueck.addEventListener('click', function () { gehe(Math.max(0, index() - 1)); });
    if (weiter) weiter.addEventListener('click', function () { gehe(index() + 1); });
    spur.addEventListener('scroll', function () { window.requestAnimationFrame(zustand); }, { passive: true });
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(baue, 150); });
    baue();
  }

  /* ---------- Versandbalken nach Warenkorb-Änderung ---------- */
  function versandAktualisieren() {
    var boxen = document.querySelectorAll('[data-nl-beau-versand]');
    if (!boxen.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        boxen.forEach(function (box) {
          var grenze = parseInt(box.getAttribute('data-schwelle'), 10) || 5000;
          var summe = cart.total_price;
          var text = box.querySelector('[data-nl-beau-versand-text]');
          var balken = box.querySelector('[data-nl-beau-versand-balken]');
          var rest = grenze - summe;
          if (balken) balken.style.width = Math.min(100, Math.round(summe * 100 / grenze)) + '%';
          if (!text) return;
          if (rest <= 0) {
            text.textContent = 'Dein Warenkorb ist versandkostenfrei.';
          } else {
            text.textContent = 'Noch ' + (rest / 100).toFixed(2).replace('.', ',') + ' € bis zum kostenlosen Versand';
          }
        });
      })
      .catch(function () { /* Balken bleibt wie geladen */ });
  }

  /* ---------- Zum Kaufbereich (Vergleich) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-nl-beau-zum-kauf]');
    if (!a || !document.querySelector('product-info')) return;
    var href = a.getAttribute('href') || '';
    if (href && href.charAt(0) !== '#' && href.indexOf(window.location.pathname) !== 0) return;
    e.preventDefault();
    zumKaufbereich(null);
  });

  /* ---------- Start ---------- */
  function nachVariantenwechsel() {
    markiereDesigns();
    setLinks();
    document.querySelectorAll('[data-nl-beau-duo]').forEach(function (d) { if (d.nlBeauAktualisiere) d.nlBeauAktualisiere(); });
  }

  function start() {
    document.querySelectorAll('[data-nl-beau-video]').forEach(video);
    document.querySelectorAll('[data-nl-beau-designs]').forEach(designs);
    document.querySelectorAll('[data-nl-beau-duo]').forEach(duo);
    document.querySelectorAll('[data-nl-beau-karussell]').forEach(karussell);
    document.querySelectorAll('[data-nl-beau-minisets]').forEach(function (root) {
      root.addEventListener('change', setLinks);
    });
    markiereDesigns();
    setLinks();
    if (hatPubSub()) {
      window.subscribe(ereignisse().variantChange, function () { setTimeout(nachVariantenwechsel, 30); });
      window.subscribe(ereignisse().cartUpdate, function () { setTimeout(versandAktualisieren, 60); });
    } else {
      document.addEventListener('change', function (e) {
        if (e.target.closest && e.target.closest('variant-selects')) setTimeout(nachVariantenwechsel, 400);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
